<script setup lang="ts">
import { ui, type ChoiceOption } from '@/app/state';
import AppDialog from './AppDialog.vue';

function pick(c: ChoiceOption) { ui.choice = null; c.act(); }
</script>

<template>
  <AppDialog :open="!!ui.choice" labelledby="choiceTitle" @close="ui.choice = null">
    <template v-if="ui.choice">
      <div class="dlg-head"><h2 id="choiceTitle" class="h-display">{{ ui.choice.title }}</h2></div>
      <p class="dlg-lede">{{ ui.choice.lede }}</p>
      <div class="dlg-acts dlg-acts--stack">
        <button v-for="(c, i) in ui.choice.choices" :key="i" type="button" class="btn" :class="c.primary ? 'btn--ink' : 'btn--quiet'" :data-choice="i" @click="pick(c)">
          {{ c.label }}<small v-if="c.sub">{{ c.sub }}</small>
        </button>
        <button type="button" class="btn btn--text" data-close @click="ui.choice = null">Cancel</button>
      </div>
    </template>
  </AppDialog>
</template>
